import CompLayout from "@/pcomponents/comp/layout/layout";
import LectureListArea from "@/pages/comp/edu/lecture/common/list";

function LectureMain() {
  return (
    <CompLayout>
      <LectureListArea></LectureListArea>
    </CompLayout>
  );
}

export default LectureMain;